import { isMobileOnly } from 'react-device-detect';
import { withLazyMounting } from '../../../components/hoc/LazyDialog';
import { ScheduleEntry } from '../../../domain/ScheduleEntry';
import { Assignment } from '../../../domain/Publisher';
import MobileScheduleEntryDialog from './MobileScheduleEntryDialog';
import DesktopScheduleEntryDialog from './DesktopScheduleEntryDialog';

interface Props {
    isOpen: boolean;
    entry?: ScheduleEntry;
    assignments: Assignment[];
    onSubmit: (entry: ScheduleEntry) => void;
    onDelete: (entry: ScheduleEntry) => void;
    onClose: () => void;
}

const ScheduleEntryDialog = (props: Props) => {
    if (isMobileOnly) {
        return <MobileScheduleEntryDialog {...props} />;
    }

    return <DesktopScheduleEntryDialog {...props} />;
};

export default withLazyMounting(ScheduleEntryDialog);
